<template lang="html">
  <section>
    <div class="botones-pagina" v-if="listado.contador">
      <button class="boton boton--rojo-tema" @click="generarReporte">
        <i class="fal fa-fw fa-file-excel"/>
        <span>Exportar a Excel</span>
      </button>
      <print-btn/>
    </div>
    <div v-if="listado.contador" class="panel fondo--blanco">
      <table class="tabla tabla--responsive">
        <thead class="tabla__header text">
          <tr>
            <th class="checkbox checkbox--rojo">
              <input type="checkbox" id="checkall" checked="true" v-model="checkAll"
                     @click="cambiarInclusion(!checkAll)">
              <label class="form__label" for="checkall">&nbsp;</label>
            </th>
            <th>#</th>
            <th>Fecha</th>
            <th>Medio</th>
            <th>Programa / Sección</th>
            <th>Edición</th>
            <th>Hora</th>
            <th>Mención</th>
            <th>Título</th>
          </tr>
        </thead>
        <tbody class="tabla__body tabla__body--clickable tabla__body--striped">
          <tr v-for="(nota, $index) in listado.docs" :key="nota._id" class="cursor-pointer">
            <td align="center" class="checkbox checkbox--rojo">
              <input class="checkbox" v-model="nota.incluir" type="checkbox" :id="`check${$index}`"
                     @click="excluir(nota)">
              <label class="form__label" :for="`check${$index}`">&nbsp;</label>
            </td>
            <router-link :to="getRutaNota(nota)" tag="td">
              {{ $index + 1 }}
            </router-link>
            <router-link :to="getRutaNota(nota)" tag="td">
              {{ nota.guionId.fecha | fecha }}
            </router-link>
            <router-link :to="getRutaNota(nota)" tag="td">
              {{ nota.guionId.medio.nombre }}
            </router-link>
            <router-link :to="getRutaNota(nota)" tag="td">
              <span v-if="!nota.seccion">{{ nota.guionId.programa.nombre }}</span>
              <span v-else>{{ nota.seccion.nombre }}</span>
            </router-link>
            <router-link :to="getRutaNota(nota)" tag="td">
              <span v-if="nota.guionId.edicion">{{ nota.guionId.edicion.nombre }}</span>
              <span v-else>N/A</span>
            </router-link>
            <router-link :to="getRutaNota(nota)" tag="td">
              <span v-if="nota.guionId.edicion">{{ nota.createdAt | fecha('hh:mm a') }}</span>
              <span v-else>N/A</span>
            </router-link>
            <router-link :to="getRutaNota(nota)" tag="td">
              {{ getMencion(nota, clienteId) }}
            </router-link>
            <router-link :to="getRutaNota(nota)" tag="td">
              {{ nota.titulo }}
            </router-link>
          </tr>
        </tbody>
      </table>
      <pagination :pagination="pagination"
                  :callback="() => { buscarNotas(filtrosGlobales, pagination.current_page) }"
                  :options="{ alwaysShowPrevNext: true }"/>
    </div>
    <div v-else>
      <p class="no-results text--center">
        <i class="fa fa-fw fa-list"/>
        <span>No hay notas registradas.</span>
      </p>
    </div>
  </section>
</template>

<script>
import pagination from "vue-bootstrap-pagination";
import orderBy from "lodash/orderBy";
import map from "lodash/map";
import find from "lodash/find";
import get from "lodash/get";
import every from "lodash/every";
import forEach from "lodash/forEach";
import keys from "lodash/keys";
import some from "lodash/some";
import toArray from "lodash/toArray";
import flatten from "lodash/flatten";
import NotaAPI from "./rest/notasApi";
import ReporteAPI from "./rest/reporteApi";

function data() {
  return {
    listado: {},
    notasExcluidas: {},
    pagination: {},
    clienteId: this.$auth.credenciales.cliente._id,
    checkAll: true,
  };
}

function getEdicion(notas) {
  const notasOrdenadas = orderBy(notas, ["fecha", "createAt"], ["desc", "desc"]);
  return map(notasOrdenadas, (nota) => {
    if (nota.guionId.programa) {
      nota.guionId.edicion = find(nota.guionId.programa.ediciones, { _id: nota.guionId.edicion });
    }
    nota.incluir = get(this.notasExcluidas[this.pagination.current_page], nota._id, true);
    return nota;
  });
}

function buscarNotas(filtros, pagActual) {
  const pagina = pagActual || 1;
  const cantPorPag = (pagina - 1) * this.pagination.per_page;
  return NotaAPI.getNotasCliente(
    this.clienteId, filtros.desde, filtros.hasta, filtros.menciones, filtros.medios, filtros.texto,
    cantPorPag, this.pagination.per_page,
  ).then((listado) => {
    listado.docs = this.getEdicion(listado.docs);
    this.listado = listado;
    this.pagination = {
      total: listado.contador,
      per_page: 50,
      current_page: pagina,
      last_page: Math.ceil(listado.contador / 50),
    };
    this.checkAll = every(this.listado.docs, "incluir");
    return listado;
  });
}

function cambiarInclusion(estado) {
  this.listado.docs.forEach((doc) => {
    doc.incluir = estado;
    if (!this.notasExcluidas[this.pagination.current_page]) {
      this.notasExcluidas[this.pagination.current_page] = {};
    }
    this.notasExcluidas[this.pagination.current_page][doc._id] = estado;
  });
}

function excluir(nota) {
  nota.incluir = !nota.incluir;
  if (!this.notasExcluidas[this.pagination.current_page]) {
    this.notasExcluidas[this.pagination.current_page] = {};
  }
  this.notasExcluidas[this.pagination.current_page][nota._id] = nota.incluir;
  this.checkAll = every(this.listado.docs, "incluir");
}

function generarReporte() {
  const algoSeleccionado = some(this.listado.docs, "incluir");
  if (algoSeleccionado) {
    const ids = getIdsExcluidos(this.notasExcluidas);
    const params = {
      cliente: this.clienteId,
      tipoMedio: this.filtrosGlobales.medios || {},
      tipoMencion: this.filtrosGlobales.menciones || {},
      fechaInicio: this.filtrosGlobales.desde,
      fechaFin: this.filtrosGlobales.hasta,
      texto: this.filtrosGlobales.texto,
    };
    return ReporteAPI
      .notasGenerar(this.clienteId, ids, params)
      .then(blobDescarga);
  }
  return false;
}

function getIdsExcluidos(excluidos) {
  const llaves = map(excluidos, (pag) => {
    forEach(pag, (v, k) => {
      if (v) delete pag[k];
    });
    return keys(pag);
  });
  return toArray(flatten(llaves));
}

function blobDescarga(datos) {
  const blob = new Blob([datos], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const elementoDescarga = document.createElement("a");
  document.body.appendChild(elementoDescarga);
  elementoDescarga.setAttribute("type", "hidden");
  elementoDescarga.href = URL.createObjectURL(blob);
  elementoDescarga.target = "_blank";
  elementoDescarga.download = "reporteNotas.xlsx";
  elementoDescarga.click();
}

function created() {
  this.$eventBus.$on("buscarNotas", this.buscarNotas);
  return NotaAPI
    .getNotasCliente(
      this.clienteId,
      this.filtrosGlobales.desde,
      this.filtrosGlobales.hasta,
      this.filtrosGlobales.menciones,
      this.filtrosGlobales.medios,
      this.filtrosGlobales.texto, 0, 50,
    )
    .then((listado) => {
      listado.docs = this.getEdicion(listado.docs);
      this.listado = listado;
      this.pagination = {
        total: listado.contador,
        per_page: 50,
        current_page: 1,
        last_page: Math.ceil(listado.contador / 50),
      };
      return listado;
    });
}

function getRutaNota(nota) {
  return { name: "nota", params: { id: nota._id }, query: { clienteId: this.clienteId } };
}

function getMencion(nota, clienteId) {
  const cliente = find(nota.clientes, ["_id._id", clienteId]);
  return cliente ? cliente.mencion : "N/A";
}

function beforeDestroy() {
  this.$eventBus.$off("buscarNotas", this.buscarNotas);
}

export default {
  components: {
    pagination,
  },
  data,
  beforeDestroy,
  created,
  methods: {
    getEdicion,
    buscarNotas,
    excluir,
    cambiarInclusion,
    generarReporte,
    getRutaNota,
    getMencion,
  },
  store: ["filtrosGlobales"],
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/notas/ListadoNotas.vue